import React, { useState } from "react";
import axios from "axios";

//const API = "http://127.0.0.1:8001";

const API = process.env.REACT_APP_API_URL;

function ProposalChangePassword() {
  const [form, setForm] = useState({
    current_password: "",
    new_password: "",
    confirm_password: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (form.new_password !== form.confirm_password) {
      setError("New passwords do not match");
      return;
    }
    if (form.new_password.length < 6) {
      setError("Password must be at least 6 characters");
      return;
    }

    setLoading(true);
    try {
      const token = sessionStorage.getItem("proposal_token");
      await axios.post(`${API}/change-password1`, form, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setSuccess("Password changed successfully!");
      setForm({ current_password: "", new_password: "", confirm_password: "" });
    } catch (err) {
      setError(err.response?.data?.detail || "Failed to change password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container">
      <h1>🔑 Change Password</h1>
      <div className="form-card">
        {error   && <div className="error-message">{error}</div>}
        {success && <div className="success-message">{success}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group-single">
            <label>Current Password</label>
            <input type="password" className="position-select" placeholder="Enter current password"
              value={form.current_password}
              onChange={(e) => setForm({ ...form, current_password: e.target.value })} required />
          </div>
          <div className="form-group-single">
            <label>New Password</label>
            <input type="password" className="position-select" placeholder="Enter new password (min 6 chars)"
              value={form.new_password}
              onChange={(e) => setForm({ ...form, new_password: e.target.value })} required />
          </div>
          <div className="form-group-single">
            <label>Confirm New Password</label>
            <input type="password" className="position-select" placeholder="Re-enter new password"
              value={form.confirm_password}
              onChange={(e) => setForm({ ...form, confirm_password: e.target.value })} required />
          </div>
          <div className="form-actions">
            <button className="btn primary" type="submit" disabled={loading}>
              {loading ? <span className="spinner" /> : "Update Password"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ProposalChangePassword;
